'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCreate$002dPolicy$002dPage$0024 from "./presto.-Create-Policy-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002451 from "./presto.-Presto-Router$$anon$51.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$50() {
  this.biD = null;
  this.biv = null;
  this.biw = false;
  this.biE = null;
  this.biF = false;
  this.biI = null;
  this.biB = null;
  this.biC = false;
  this.bix = null;
  this.biy = false;
  this.biz = null;
  this.biA = false;
  this.biG = false;
  this.biH = false;
  this.biD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.biI = "CreatePolicyPage";
}
export { $c_Lpresto_PrestoRouter$$anon$50 as $c_Lpresto_PrestoRouter$$anon$50 };
$p = $c_Lpresto_PrestoRouter$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$50;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$50() {
}
export { $h_Lpresto_PrestoRouter$$anon$50 as $h_Lpresto_PrestoRouter$$anon$50 };
$h_Lpresto_PrestoRouter$$anon$50.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.biD;
});
$p.M = (function() {
  if ((!this.biw)) {
    this.biv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biw = true;
  }
  return this.biv;
});
$p.O = (function() {
  if ((!this.biF)) {
    this.biE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.biF = true;
  }
  return this.biE;
});
$p.E = (function() {
  return this.biI;
});
$p.t = (function() {
  if ((!this.biC)) {
    this.biB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biC = true;
  }
  return this.biB;
});
$p.N = (function() {
  if ((!this.biy)) {
    this.bix = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biy = true;
  }
  return this.bix;
});
$p.Q = (function() {
  if ((!this.biA)) {
    this.biz = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002451.$c_Lpresto_PrestoRouter$$anon$51();
    this.biA = true;
  }
  return this.biz;
});
$p.v = (function() {
  if ((!this.biH)) {
    this.biG = false;
    this.biH = true;
  }
  return this.biG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee391) => ((p) => \u03b4scrutinee391))($j_presto$002e$002dCreate$002dPolicy$002dPage$0024.$m_Lpresto_CreatePolicyPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$50, "presto.PrestoRouter$$anon$50", ({
  Or: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$50 as $d_Lpresto_PrestoRouter$$anon$50 };
//# sourceMappingURL=presto.-Presto-Router$$anon$50.js.map
